var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:['tab-button', { 'tab-button--active': _vm.isActive }],on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.iconSrc)?_c('img',{staticClass:"tab-button__icon",attrs:{"src":_vm.iconSrc,"alt":_vm.iconAlt}}):_vm._e(),_c('span',{staticClass:"tab-button__text"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }